import request from '@/utils/request'


export const websiteApi = {
    initActivity() {
        return request({
            url: 'MARKETING/api/platform/v1/campaign/init',
            method: 'get',
        });
    }, 
    getGoods(params) {
        return request({        
            url: 'product/v1/goods',
            method: 'post',
            data:params
        });
    },
    getAddLead(params) {
        return request({        
            url: 'sagent/v1/leads',
            method: 'post',
            data:params
        });
    },
    getAlbum(params){
        return request({
            url: '/cms/v1/album',
            methods: 'get',
            params
        })
    },
    getConfig(params){
        return request({
            url: '/config/v1/getconfig',
            methods: 'get',
            params
        })
    },
    getArticle(params){
        return request({
            url: '/cms/v1/article',
            methods: 'get',
            params
        })
    },
    getClient(params){
        return request({
            url: '/config/v1/client',
            methods: 'get',
            params
        })
    },
    getLoop(params){
        return request({
            url: '/cms/v1/loop',
            methods: 'get',
            params
        })
    }
}